import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('efa_cmp_-_eap_fast_follow_field_scheme_operations');
	},
};
